
import store from "@/store";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {defineComponent} from 'vue'
import router from "@/router";

export default defineComponent({
    name: 'App',
    components: {"loading":Loading},
    data(){
        return{
            before_route : ''
            ,logoutUrl: process.env.VUE_APP_AUTH_SERVER_URL + 'logout'
            ,homeUrl: process.env.VUE_APP_AUTH_SERVER_URL + 'groundMenu'
            ,appVersion: process.env.VUE_APP_VERSION
            ,timestamp: new Date().getTime()
        }
    },
    computed: {
        loading: {
            get(): boolean {
                return store.getters.loading
            },
            set(loading: boolean) {
                store.commit('setLoading', loading)
            }
        },
        fluid(){
            if(this.$route.name === 'masterMaintenance'){
                return false
            }else{
                return true
            }
        },
        showNav(){
          console.log('>>>>>>>>>>>>>>>>' + this.$route.path)
            if(this.$route.name === 'logout' || this.$route.name === 'login' || this.$route.name === 'menu' || this.$route.name === 'toroku' || this.$route.name === 'torokuannai' || this.$route.name?.toString().startsWith('passwordReminder')){
                return false
            }else{
                return true
            }
        }
    },
    methods: {
        router() {
            return router
        },
        search(options: [], search: string) {
            return options
        },
        goBukkenRegister(){
            //this.$router.push({path: '/', force: true});
            setTimeout(()=>{
                this.$router.push({path: '/bukkenRegister.app'});
            },0)

        }
    },
});
